import axios from 'axios'
import * as Sentry from '@sentry/vue'

export const translationProcessing = {
  openRequest: indexedDB.open('store'),
  currentRoutes: [...window.translationParams.route.split(','), 'layouts/main'],
  translationsConfig: () => window?.config?.i18n,
  init (callbackFunction) {
    this.openRequest.onupgradeneeded = ({ target }) => {
      this.createStore(target.result)
    }
    this.openRequest.onsuccess = ({ target }) => {
      for (let i = 0; i < this.currentRoutes.length; i++) {
        const params = {
          db: target.result,
          translations: {
            data: this.translationsConfig()[this.currentRoutes[i]]?.data,
            version: this.translationsConfig()[this.currentRoutes[i]]?.version
          },
          route: this.currentRoutes[i],
          callbackFunction
        }
        if (this.translationsConfig()) {
          if (this.translationsConfig()[this.currentRoutes[i]]) {
            this.getTranslations(target.result, this.currentRoutes[i])
              .then(translationsFromIdb => {
                if (!translationsFromIdb || translationsFromIdb.value.version < this.translationsConfig()[this.currentRoutes[i]].version) {
                  if (this.translationsConfig()[this.currentRoutes[i]].data) {
                    this.addTranslationsToIdb(params)
                  } else {
                    this.addFetchedTranslationsToIdb(params)
                  }
                } else {
                  callbackFunction(translationsFromIdb)
                }
              })
          } else {
            callbackFunction({ notUpdate: true })
          }
        } else {
          this.fetchTranslations(this.currentRoutes[i])
            .then(res => {
              const data = { route: this.currentRoutes[i], value: res[this.currentRoutes[i]] }
              this.addTranslationsToIdb(params)
              callbackFunction(data)
            })
            .catch(e => {
              this.sendErrorToSentry('Can not fetch translations from server', { error: e })
            })
        }
      }
    }

    this.openRequest.onerror = () => {
      for (let i = 0; i < this.currentRoutes.length; i++) {
        this.fetchTranslations(this.currentRoutes[i])
          .then(res => {
            const data = { route: this.currentRoutes[i], value: res[this.currentRoutes[i]] }
            callbackFunction(data)
          })
          .catch(e => {
            this.sendErrorToSentry('Can not fetch translations from server', { error: e })
          })
      }
    }
  },
  createStore (db) {
    if (!db.objectStoreNames.contains('translation')) {
      db.createObjectStore('translation', { keyPath: 'route' })
    }
  },
  addFetchedTranslationsToIdb ({ db, callbackFunction, route }) {
    this.fetchTranslations(route)
      .then(response => {
        this.addTranslationsToIdb({ db, translations: response[route], callbackFunction, route })
      })
      .catch(e => {
        this.sendErrorToSentry('Can not fetch translations from server', { error: e })
      })
  },
  addTranslationsToIdb ({ db, translations, callbackFunction, route }) {
    const tx = db.transaction('translation', 'readwrite')
    const store = tx.objectStore('translation')
    const data = { route, value: translations }
    const addTranslation = store.put(data)

    addTranslation.onsuccess = () => callbackFunction(data)
    addTranslation.onerror = (e) => {
      this.sendErrorToSentry('Can not add translations to IDb', { error: e })
    }
  },
  getTranslations (db, route) {
    return new Promise(resolve => {
      const tx = db.transaction('translation', 'readonly')
      const translations = tx.objectStore('translation').get(route)

      translations.onsuccess = ({ target }) => resolve(target.result)
      translations.onerror = (e) => {
        this.sendErrorToSentry('Can not get translations from IDb', { error: e })
      }
    })
  },
  fetchTranslations (route) {
    return new Promise((resolve, reject) => {
      axios.get('/language/get/?routes=' + route)
        .then(response => resolve(response.data))
        .catch(e => reject(e))
    })
  },
  sendErrorToSentry (message, data) {
    Sentry.captureMessage(message, { extra: { ...data }, tags: { category: 'translations' } })
  }
}
